export default __webpack_public_path__ + "static/54-a02a6be00e2e4111c8deff75bd531286.gif";